import { DateTime } from "luxon";
import { User } from "@/lib/api/user";
import { DEFAULT_TIMEZONE } from "@/lib/constants";

/**
 * Get the device's current timezone
 * @returns IANA timezone string (e.g., 'America/New_York', 'Europe/London')
 */
export function getDeviceTimezone(): string {
  return DateTime.local().zoneName || "UTC";
}

/**
 * Get timezone for a user, falling back to device timezone if not set in metadata
 * Use this when you want to display times in the current user's context
 * @param user - User object with optional metadata.timezone
 * @returns IANA timezone string
 */
export function getUserTimezone(user?: User | null): string {
  if (user?.metadata?.timezone) {
    return user.metadata.timezone;
  }
  return getDeviceTimezone();
}

/**
 * Get timezone for displaying another user's schedule/data
 * Falls back to default timezone (EST) instead of device timezone
 * Use this when displaying mentor schedules or other user's timezone-specific data
 * @param user - User object with optional metadata.timezone
 * @returns IANA timezone string
 */
export function getUserTimezoneWithDefault(user?: User | null): string {
  if (user?.metadata?.timezone) {
    return user.metadata.timezone;
  }
  return DEFAULT_TIMEZONE;
}

export const usaTimezones = [
  DEFAULT_TIMEZONE,
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Anchorage",
  "America/Adak",
  "Pacific/Honolulu",
];
